const Balance = {
  Peso: "peso",
  Diesel: "diesel",
  Gas91: "gas91",
  Gas95: "gas95",
  Gas97: "gas97",
};

export default Balance;
